import React from "react";
import star from "../../assets/images/devdetail/starbt.png";
import img1 from "../../assets/images/devdetail/Avatar1.png";
import img2 from "../../assets/images/devdetail/Avatar2.png";
import img3 from "../../assets/images/devdetail/Avatar3.png";
import img4 from "../../assets/images/devdetail/Avatar4.png";
import img5 from "../../assets/images/devdetail/Avatar5.png";
import img6 from "../../assets/images/devdetail/Avatar6.png";
import ProgressBar from "react-bootstrap/ProgressBar";

const Devdetailreview = () => {
  const reviewsArr = [
    {
      img: img1,
      name: "Jose",
      date: "December 2021",
      discription: "Host was very attentive.",
    },
    {
      img: img2,
      name: "Luke",
      date: "December 2021",
      discription: "Nice place to stay!",
    },
    {
      img: img3,
      name: "Shayna",
      date: "December 2021",
      discription:
        "Wonderful neighborhood, easy access to restaurants and the subway, cozy studio apartment with a super comfortable bed. Great host, super helpful and responsive. Cool murphy bed...",
    },
    {
      img: img4,
      name: "Josh",
      date: "November 2021",
      discription:
        "Well designed and fun space, neighborhood has lots of energy and amenities.",
    },
    {
      img: img5,
      name: "Vladko",
      date: "November 2020",
      discription:
        "This is amazing place. It has everything one needs for a monthly business stay. Very clean and organized place. Amazing hospitality affordable price.",
    },
    {
      img: img6,
      name: "Jennifer",
      date: "January 2022",
      discription:
        "A centric place, near of a sub station and a supermarket with everything you need. ...",
    },
  ];

  return (
    <div className=' dev-detail-reviews'>
      <ul>
        <li>
          <img src={star} alt='' className='dev-detail-content-top-img'></img>
          5.0
        </li>
        <li>7 reviews</li>
      </ul>
      <div className='dev-detail-reviews dev-detail-reviews-border'>
        <div className='dev-detail-reviews-rating dev-detail-reviews-barfill'>
          <div className='dev-detail-rating-bars'>
            <div className='dev-detail-rating-left'>
              <p>Timing</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={100} />
                <span>5.0</span>
              </div>
            </div>
            <div className='dev-detail-rating-left'>
              <p>Communication</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={100} />
                <span>5.0</span>
              </div>
            </div>
            <div className='dev-detail-rating-left'>
              <p>Check-in</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={100} />
                <span>5.0</span>
              </div>
            </div>
          </div>
          <div className='dev-detail-rating-bars'>
            <div className='dev-detail-rating-left'>
              <p>Accuracy</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={100} />
                <span>5.0</span>
              </div>
            </div>
            <div className='dev-detail-rating-left'>
              <p>Location</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={90} />
                <span>4.9</span>
              </div>
            </div>
            <div className='dev-detail-rating-left'>
              <p>Value</p>
              <div className='dev-detail-rating-rate'>
                <ProgressBar variant='dark' now={70} />
                <span>4.7</span>
              </div>
            </div>
          </div>
        </div>
        <div className='dev-detail-reviews-rating'>
          <div class='autofill'>
            {reviewsArr.map((item) => {
              return (
                <>
                  <div class='item1'>
                    <div className='dev-detail-reviews-client'>
                      <img src={item.img} alt=''></img>
                      <div>
                        <p className='dev-detail-reviews-name'>{item.name}</p>
                        <p className='dev-detail-reviews-date'>{item.date}</p>
                      </div>
                    </div>
                    <p className='dev-detail-reviews-discription'>
                      {item.discription}
                    </p>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <button className='reviews-btn'>Show all 12 Reviews</button>
      </div>
    </div>
  );
};

export default Devdetailreview;
